const React = require('react');
const {default: CancelIcon} = require("@material-ui/icons/Cancel");
const Ripple = require("../../../../../Ripple");
const SearchIcon = require('@material-ui/icons/Search').default;

module.exports = ({
  className,
  maxLength,
  value = '',
  ...props
}) => {
  return (
    <div className={`rlv ` + (props.disabled ? 'disabled ' : '') + (className || '')}>
      <div className="abs st50% sl23 x0y-50% layoutRow fhaC fvaC">
        <SearchIcon className="sq21*2 c8"/>
      </div>
      <input
        {...props}
        className="f12 ff$3 h45 w pl45 pr70 bs b1 bc8
          olN cCT (cCT|o100):i r9 dn bc0:(h|f)<1:not[.disabled] o50<1.disabled"
        value={maxLength && value.length > maxLength ? value.slice(0, maxLength) : value}
      />
      <Ripple
        className={
          `layoutRow fhaC fvaC bg5B47FF abs w45 h sr0 st0 r0_9_9_0 dn o75.disabled`
          + (!value ? ' disabled ' : '')
        }
        onClick={() => props.onChange && props.onChange({target: {value: ''}})}
        disabled={!value}
      >
        <CancelIcon className="sq21*2 cF" />
      </Ripple>
      {/*<div className="layoutRow fhaC fvaC bg5B47FF abs w45 svr r0_9_9_0 bgA3A7AC<1.disabled">*/}
      {/*  <SearchIcon className="sq21*2 cF"/>*/}
      {/*</div>*/}
    </div>
  );
};

